var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.13 22.655q-.825 0-1.412-.588a1.93 1.93 0 0 1-.587-1.412v-14q0-.825.587-1.413a1.93 1.93 0 0 1 1.413-.587h1v-2h2v2h8v-2h2v2h1q.825 0 1.412.587.588.588.588 1.413v14q0 .825-.588 1.412a1.93 1.93 0 0 1-1.412.588zm0-2h14v-10h-14z"
  })));
};
export default SvgCalendar;